import { render, staticRenderFns } from "./FullscreenDialog.vue?vue&type=template&id=e8db33f8"
import script from "./FullscreenDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./FullscreenDialog.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports